import React from 'react';
import { useEffect } from 'react';


//Zoho Sales Iq Script:
const useScript = (url, widgetCode, userEmail) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;

    let code = `
      var $zoho=$zoho || {};
      $zoho.salesiq = $zoho.salesiq || {widgetcode: "${widgetCode}", values:{},ready:function(){}};
      var d=document;
      s=d.createElement("script");
      s.type="text/javascript";
      s.id="zsiqscript";
      s.defer=true;
      s.src="${url}";
      t=d.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(s,t);
      d.innerHTML = "<div id='zsiqwidget'></div>";

      // Register visitor with Zoho Sales IQ
      $zoho.salesiq.ready = function(){
        $zoho.salesiq.registerVisitor({
          email: "${userEmail}",
          // You can add more properties here as per your requirement
        });
      };
    `
    
    script.appendChild(document.createTextNode(code));
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url, widgetCode, userEmail]);
};

const SalesIQChatWidget = ({ userEmail }) => {
  useScript('https://salesiq.zoho.eu/widget', "siq2cd8b2edd54ac6680c72904f7ec7b544534faaab8e8ce7c948ef7a66fdf2c6bb", userEmail);

  return null; // Since this component only handles script injection, return null or empty fragment
};

export default SalesIQChatWidget;
